/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 24.05.2016.
 */

import React, {Component, PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import shallowCompare from 'react-addons-shallow-compare';
import {VelocityComponent} from 'velocity-react';

import _at from 'lodash/at';
import _filter from 'lodash/filter';
import _get from 'lodash/get';
import _cloneDeep from 'lodash/cloneDeep';

import EpgEvent from './epg-grid-event-item';

import { GetProgramGuideById } from '../../actions/schedule/actions-schedule';

class EpgGridEventsRow extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isExtended: false,
      selectedEvent: {},
      events: []
    }
  }

  shouldComponentUpdate(nextProps, nextState) {

    return shallowCompare(this, nextProps, nextState);
  }

  _needToHide(offsetX, widthPx) {

    return _get(this.props, 'offset.leftPosition', 0) > (offsetX + widthPx + 100)
      || _get(this.props, 'offset.leftPosition', 0) + 1050 < (offsetX - 100);
  }

  _onEventSelect = (obj) => {
    let event = _cloneDeep(obj);

    this.props.onExtendEpgRow(this.props.row, event);
  };

  _renderEvents() {

    return this.props.events.filter((event) => {
      event._offset = (parseInt((event.start - this.props.start) / 60 * this.props.pxInMin, 10));
      event._width = (parseInt((event.duration) / 60 * this.props.pxInMin - this.props.pxInMin, 10));

      return !this._needToHide(event._offset, event._width);
    })
      .map((event, index) => {

      return (
        <EpgEvent
          onEventSelect={this._onEventSelect}
          event={event}
          key={'program_' + event.id}
          col={index}
          row={this.props.row}
          isToday={this.props.isToday}
          now={this.props.now}
          gridOffset={this.props.offset} />);
    });
  }

  render() {

    let animationOnExpand = {
      marginTop: this.props.isExtend ? 0 : '-270px',
      marginBottom: this.props.isExtend ? '6px' : 0
    };

    let animationProfileContainer = {
      height: this.props.isExtend ? 339 : 63
    };

    return (<div id="epg-channel-container" className="epg-channel-container" data-row={this.props.row} style={{width: (1050 / _get(Config, 'epg.epg_container_window_in_min', 180)) * 1440 + 'px'}}>
      <VelocityComponent animation={animationProfileContainer} duration={350}>
        <div className="profile-container epg-channel-row">
          <VelocityComponent animation={animationOnExpand} duration={350}>
            <div className="showcase-expanded-profile" id="showcase_expanded_tile"></div>
          </VelocityComponent>
          <div id="epg-channel-row">
            <div className="blocks-epg radius clearfix">
              <div className="blocks-epg-swipe radius">
                {!this.props.needToHide && this._renderEvents()}
              </div>
            </div>
          </div>
        </div>
      </VelocityComponent>
    </div>);
  }
}

EpgGridEventsRow.propTypes = {
  row: PropTypes.number.isRequired,
  end: PropTypes.number.isRequired,
  offset: PropTypes.object.isRequired,
  needToHide: PropTypes.bool.isRequired,
  onExtendEpgRow: PropTypes.func.isRequired,
  isExtend: PropTypes.bool.isRequired,
  schedule: PropTypes.array.isRequired,
  start: PropTypes.number.isRequired,
  pxInMin: PropTypes.number.isRequired,
  isToday: PropTypes.bool.isRequired,
  now: PropTypes.number
};

const mapStateToProps = ({schedule: { event }}, ownProps) => {
  var events = _filter(_at(event, _get(ownProps, 'schedule', [])), 'id');

  return {
    events: events
  }
};

export default connect(mapStateToProps, (dispatch) => { return bindActionCreators({GetProgramGuideById}, dispatch)})(EpgGridEventsRow);



// WEBPACK FOOTER //
// ./src/components/EPGGrid/epg-grid-schedule-row.js